import React from "react";
import { Link } from "react-router";

export const NotFound = () => (
  <div className="columns">
    <div className="column is-4 is-offset-4" style={{ textAlign: "center" }}>
      <img src="/images/logo-accent.png" width={200} height={200} />
      <h1>Page not found</h1>
      <p><Link to="/">Click here to go home</Link></p>
    </div>
  </div>
);
